import { settings } from "../settings";
import { drawOptionDescription } from "./drawOptionDescription";
export const drawSliderOption = (parent, option) => {
    const currentSettingValue = settings[option.id];
    const optionEL = document.createElement("div");
    optionEL.className = "sliderBox";
    optionEL.style.width = "230px";
    const optionLabel = document.createElement("div");
    optionLabel.style.float = "left";
    optionLabel.className = "smallFancyButton";
    optionLabel.innerHTML = option.name;
    const optionValue = document.createElement("div");
    optionValue.style.float = "right";
    optionValue.className = "smallFancyButton";
    optionValue.innerHTML = option.valueFormat(currentSettingValue);
    const settingInput = document.createElement("input");
    settingInput.className = "slider";
    settingInput.type = "range";
    settingInput.min = String(option.min);
    settingInput.max = String(option.max);
    settingInput.step = String(option.step);
    settingInput.value = String(currentSettingValue !== undefined ? currentSettingValue : option.default);
    optionEL.appendChild(optionLabel);
    optionEL.appendChild(optionValue);
    optionEL.appendChild(settingInput);
    const setSetting = (val) => {
        settings[option.id] = +val;
        optionValue.innerHTML = option.valueFormat(+val);
        option.onChange?.(+val);
    };
    optionEL.onchange = () => {
        setSetting(settingInput.value);
        PlaySound("snd/tick.mp3");
    };
    optionEL.oninput = () => {
        setSetting(settingInput.value);
    };
    parent.appendChild(optionEL);
    drawOptionDescription(parent, option.description, {
        position: "relative",
        display: "inline-block",
        top: "-9px",
    });
    parent.appendChild(document.createElement("br"));
};
